(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("loading", [], factory);
	else if(typeof exports === 'object')
		exports["loading"] = factory();
	else
		root["loading"] = factory();
})(window, function() {
return 